module.exports = __webpack_public_path__ + "img/qr_code_frame.0d9889d6.png";